import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
import LturSocial from "Common/LturSocial.vue";
var initializeLturSocial = function () {
    Vue.use(VueCustomElement);
    Vue.customElement('c-ltur-social', (new LturSocial().$options), vueCustomElementOptions);
};
export default initializeLturSocial;
